import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import arTranslation from '../locales/ar/translation.json';
import enTranslation from '../locales/en/translation.json';

const STORAGE_KEY = 'saee-locale';

/** Broker URL language preference (persists across reload and `/` redirect). */
export function getStoredLocale(): 'en' | 'ar' {
  if (typeof window === 'undefined') return 'ar';
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored === 'en' || stored === 'ar' ? stored : 'ar';
}

const getInitialLng = (): string => {
  if (typeof window === 'undefined') return 'ar';
  const lng = getStoredLocale();
  document.documentElement.lang = lng;
  document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
  document.body?.setAttribute('dir', lng === 'ar' ? 'rtl' : 'ltr');
  return lng;
};

/**
 * Bundle locale JSON in the app so keys always resolve (no race or /locales fetch failures in Docker/proxy).
 * Canonical files live under src/locales (Vite cannot import from public/); tooling reads the same paths.
 */
i18n.use(initReactI18next).init({
  lng: getInitialLng(),
  fallbackLng: 'en',
  supportedLngs: ['ar', 'en'],
  load: 'languageOnly',
  defaultNS: 'translation',
  ns: ['translation'],
  resources: {
    ar: { translation: arTranslation },
    en: { translation: enTranslation },
  },
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: true,
  },
});

export default i18n;
export { STORAGE_KEY };
